import { projectsSelectProject } from '@slices/projects';

import { writeProjectsSelectedProjectId } from '@storage/projects';

import { ProjectsHandleSelect } from './types';

export const projectsHandleSelect: ProjectsHandleSelect =
  (payload) => (dispatch) => {
    const { projectId } = payload;

    writeProjectsSelectedProjectId(projectId);

    dispatch(projectsSelectProject({ projectId }));
  };
